import { SearchModel } from '@app/entities/models/search/search-model.model';
import { SearchPublication } from '@app/entities/models/search/search-publication.model';
import { SearchSection } from '@app/entities/models/search/search-section.model';

export class Search {
  sections!: SearchSection;
  publications!: SearchPublication;
  modelSections!: SearchModel;
}
